export function getStaticUrl(settings, fragment = '') {
  return `${settings.staticUrl}portal/${fragment}`
}



/** WEBPACK FOOTER **
 ** ./src/utils/files/files.js
 **/